import {
    FETCH_COMBO_COLOR_REQUEST,
    FETCH_COMBO_COLOR_SUCCESS,
    FETCH_COMBO_COLOR_FAILURE,
    UPDATE_COMBO_COLOR_SUCCESS,
    UPDATE_COMBO_COLOR_REQUEST,
    UPDATE_COMBO_COLOR_FAILURE,
    RESET_COMBO_COLOR_ARRAY_DATA,
    RESET_COMBO_COLOR_FOR_PART_REQUEST,
    RESET_COMBO_COLOR_FOR_PART_SUCCESS,
    RESET_COMBO_COLOR_FOR_PART_FAILURE,
    FETCH_COMBO_COLOR_INVOICE_REQUEST,
    FETCH_COMBO_COLOR_INVOICE_SUCCESS,
    FETCH_COMBO_COLOR_INVOICE_FAILURE,
    RESET_COMBO_COLOR_INVOICE,
    FETCH_COMBO_COLOR_LISTS_SUCCESS,
    GET_FOLDING_FABRIC_REQUEST,
    GET_FOLDING_FABRIC_FAILURE,
    GET_FOLDING_FABRIC_SUCCESS,
    GET_FOLDING_FABRIC_DETAILS_REQUEST,
    GET_FOLDING_FABRIC_DETAILS_FAILURE,
    GET_FOLDING_FABRIC_DETAILS_SUCCESS
} from './comboColor.actionsType';

export const COMBO_COLOR = 'comboColor';

let initialState = {
    loading: false,
    comboColorList: [],
    resetComboColorData: [],
    errorMessage: '',
    combocolorInvoice: [],
    foldingFabricData: [],
    foldingFabricDetails: []
};

export let comboColorReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_COMBO_COLOR_REQUEST:
        case RESET_COMBO_COLOR_FOR_PART_REQUEST:
        case UPDATE_COMBO_COLOR_REQUEST:
        case FETCH_COMBO_COLOR_INVOICE_REQUEST:
        case GET_FOLDING_FABRIC_REQUEST:
        case GET_FOLDING_FABRIC_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case RESET_COMBO_COLOR_ARRAY_DATA:
            return {
                ...state,
                comboColorList: []
            };
        case FETCH_COMBO_COLOR_SUCCESS:
            return {
                ...state,
                loading: false,
                comboColorList: updatePayload,
                resetComboColorData: []
            };
        case GET_FOLDING_FABRIC_SUCCESS:
            return {
                ...state,
                foldingFabricData: updatePayload
            };
        case GET_FOLDING_FABRIC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                foldingFabricDetails: updatePayload
            };
        case FETCH_COMBO_COLOR_LISTS_SUCCESS:
            return {
                ...state,
                loading: false,
                comboColorListsNew: updatePayload
            }
        case RESET_COMBO_COLOR_FOR_PART_SUCCESS:
            return {
                ...state,
                loading: false
                // resetComboColorData: updatePayload
            };
        case UPDATE_COMBO_COLOR_SUCCESS:
            return {
                ...state,
                loading: false,
                pcsWeightForm: {},
                comboColorList: [],
                resetComboColorData: []
            };
        case FETCH_COMBO_COLOR_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                combocolorInvoice: updatePayload
            };
        case RESET_COMBO_COLOR_INVOICE:
            return {
                ...state,
                combocolorInvoice: []
            };
        case FETCH_COMBO_COLOR_FAILURE:
        case RESET_COMBO_COLOR_FOR_PART_FAILURE:
        case UPDATE_COMBO_COLOR_FAILURE:
        case FETCH_COMBO_COLOR_INVOICE_FAILURE:
        case GET_FOLDING_FABRIC_FAILURE:
        case GET_FOLDING_FABRIC_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
